import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC023_Request,
  IAPI_FAC023_Response,
} from "../../../type/apiType";
import {
  IAPI_FAC024_Request,
  IAPI_FAC024_Response,
} from "../../../type/apiType";
import {
  IAPI_CON030_Request,
  IAPI_CON030_Response,
} from "../../../type/apiType/IAPI_CON030";
import {
  IAPI_CON031_Request,
  IAPI_CON031_Response,
} from "../../../type/apiType";

// 部分解除対象施設一覧表示API
const httpAPI_FAC023 = async (
  param: IAPI_FAC023_Request
): Promise<IAPI_FAC023_Response> => {
  const res = await http.post(ApiUrl.API_FAC023, { ...param });
  return res.data;
};

// 部分解除対象施設削除API
const httpAPI_FAC024 = async (
  param: IAPI_FAC024_Request
): Promise<IAPI_FAC024_Response> => {
  const res = await http.post(ApiUrl.API_FAC024, { ...param });
  return res.data;
};

// 日々更新法人職員系の退職年月日削除職員確認API
const httpAPI_CON031 = async (
  param: IAPI_CON031_Request
): Promise<IAPI_CON031_Response> => {
  const res = await http.post(ApiUrl.API_CON031, { ...param });
  return res.data;
};

// 日々更新法人職員系の退職年月日削除API
const httpAPI_CON030 = async (
  param: IAPI_CON030_Request
): Promise<IAPI_CON030_Response> => {
  const res = await http.post(ApiUrl.API_CON030, { ...param });
  return res.data;
};

export { httpAPI_FAC023, httpAPI_FAC024, httpAPI_CON031, httpAPI_CON030 };
